<template>
  <div class="pt-9 px-md-5">
    <b-card no-body>
      <b-card-header class="border-0">
        <b-row align-v="center" slot="header">
          <b-col cols="12">
            <b-form
              @submit.prevent="findCategoria"
              v-loading="loadingCategoria || loadingListagem"
            >
              <b-row>
                <b-col sm="9" lg="4">
                  <base-input
                    type="text"
                    label="Senha da Categoria"
                    name="Senha da Categoria"
                    placeholder="Digite a senha da categoria"
                    v-model="senhaCategoria"
                  >
                  </base-input>
                </b-col>
                <b-col sm="3" lg="4">
                  <div>
                    <label class="form-control-label invisible">.</label>
                  </div>

                  <base-button
                    :loading="loadingCategoria"
                    type="primary"
                    native-type="submit"
                  >
                    Buscar
                  </base-button>
                  <b-icon
                    icon="question-circle"
                    v-b-tooltip.hover
                    title="Para votar nas peças, preencha a senha da categoria desejada."
                    style="width: 20px; height: 20px"
                    class="ml-2"
                  ></b-icon>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
          <b-col cols="4" class="text-right"> </b-col>
        </b-row>
      </b-card-header>
      <el-table
        class="table-responsive table"
        header-row-class-name="thead-light"
        :data="pecas"
        v-loading="loadingListagem"
        v-if="categoriaType"
        empty-text="Não há dados para mostrar. "
      >
        <el-table-column
          v-if="categoriaType !== 'ESTUDANTE'"
          label="Nome da Peça"
          prop="pecaTitulo"
          min-width="140px"
        >
        </el-table-column>
        <el-table-column v-else label="Grupo" prop="grupo" min-width="140px">
        </el-table-column>

        <el-table-column
          v-if="categoriaType !== 'ESTUDANTE'"
          label="Peça"
          prop="arquivo1"
          min-width="120px"
        >
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              <a
                :href="'/uploads/' + DEPLOYED_YEAR + '/' + row.arquivo1"
                class="btn btn-sm btn-info"
                target="_blank"
                v-if="row.arquivo1"
              >
                Ver Peça
              </a>
              <a
                :href="
                  new RegExp('^(?:[a-z+]+:)?//', 'i').test(row.url)
                    ? row.url
                    : `//${row.url}`
                "
                class="btn btn-sm btn-info"
                target="_blank"
                v-if="row.url"
              >
                Ver Link
              </a>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-else label="Peça" prop="arquivo" min-width="120px">
          <template v-slot="{ row }">
            <div class="d-flex align-items-center">
              <a
                :href="'/uploads/' + DEPLOYED_YEAR + '/' + row.arquivo"
                class="btn btn-sm btn-info"
                target="_blank"
                v-if="row.arquivo"
              >
                Ver Peça
              </a>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Votar" min-width="140px">
          <template v-slot="{ row }">
            <div class="d-flex align-items-center" v-if="!row.votado">
              <base-button
                v-b-modal.modal-vote
                size="sm"
                type="success"
                @click="openVoteModal(row)"
              >
                Votar
              </base-button>
            </div>
            <div v-else>VOTADO</div>
          </template>
        </el-table-column>
      </el-table>

      <!-- <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="10"
        ></base-pagination>
      </b-card-footer> -->
    </b-card>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-modal
        id="modal-vote"
        centered
        title="Votação"
        ok-title="Votar"
        cancel-title="Cancelar"
        size="lg"
        @hidden="resetVoteModal"
        @ok="handleSubmit(saveVote)"
      >
        <b-form @submit.prevent="handleSubmit(saveVote)" v-loading="loading">
          <h6 class="heading-small text-muted">Peça</h6>

          <b-row>
            <b-col cols="9">
              <base-input
                v-if="categoriaType !== 'ESTUDANTE'"
                type="text"
                label="Título da peça"
                name="Título da peça"
                placeholder="Vazio"
                v-model="selectedPeca.pecaTitulo"
                disabled
              >
              </base-input>
              <base-input
                v-else
                type="text"
                label="Grupo"
                name="Grupo"
                placeholder="Vazio"
                v-model="selectedPeca.grupo"
                disabled
              >
              </base-input>
            </b-col>
            <b-col cols="3">
              <label class="form-control-label">Peça</label>
              <div
                class="d-flex align-items-center"
                v-if="categoriaType !== 'ESTUDANTE'"
              >
                <a
                  :href="
                    '/uploads/' + DEPLOYED_YEAR + '/' + selectedPeca.arquivo1
                  "
                  class="btn btn-sm btn-info"
                  target="_blank"
                  v-if="selectedPeca.arquivo1"
                >
                  Ver Peça
                </a>
                <a
                  :href="
                    new RegExp('^(?:[a-z+]+:)?//', 'i').test(selectedPeca.url)
                      ? selectedPeca.url
                      : `//${selectedPeca.url}`
                  "
                  class="btn btn-sm btn-info"
                  target="_blank"
                  v-if="selectedPeca.url"
                >
                  Ver Link
                </a>
              </div>
              <div v-else class="d-flex align-items-center">
                <a
                  :href="
                    '/uploads/' + DEPLOYED_YEAR + '/' + selectedPeca.arquivo
                  "
                  class="btn btn-sm btn-info"
                  target="_blank"
                  v-if="selectedPeca.arquivo"
                >
                  Ver Peça
                </a>
              </div>
            </b-col>
          </b-row>

          <div v-if="selectedPeca.conceito">
            <h6 class="heading-small text-muted mb-3">Resumo</h6>
            <b-row>
              <b-col cols="12">
                <div>
                  {{ selectedPeca.conceito }}
                </div>
              </b-col>
            </b-row>
          </div>

          <div v-if="selectedPeca.conceitoPeca">
            <h6 class="heading-small text-muted mb-3">Resumo</h6>
            <b-row>
              <b-col cols="12">
                <div>
                  {{ selectedPeca.conceitoPeca }}
                </div>
              </b-col>
            </b-row>
          </div>

          <hr class="my-4" />
          <h6 class="heading-small text-muted my-4">Notas</h6>
          <b-row>
            <b-col lg="4">
              <base-input
                id="criatividade"
                type="text"
                label="Criatividade"
                name="Criatividade"
                placeholder="Digite um valor de 5 a 10"
                v-model="criatividade"
                @keyup="handleChange"
                rules="min_value:5|max_value:10"
              >
              </base-input>
            </b-col>
            <b-col lg="4">
              <base-input
                type="text"
                label="Inovação"
                name="Inovação"
                placeholder="Digite um valor de 5 a 10"
                v-model="inovacao"
                @keyup="handleChange"
                rules="min_value:5|max_value:10"
              >
              </base-input>
            </b-col>
            <b-col lg="4">
              <base-input
                type="text"
                label="Pertinência"
                name="Pertinência"
                placeholder="Digite um valor de 5 a 10"
                v-model="pertinencia"
                @keyup="handleChange"
                rules="min_value:5|max_value:10"
              >
              </base-input>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import api from "@/services/api";
import { DEPLOYED_YEAR } from "@/util/constants";

export default {
  name: "home-jurado",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      DEPLOYED_YEAR,
      loading: false,
      loadingListagem: false,
      loadingCategoria: false,
      senhaCategoria: "",
      showModal: false,
      pecas: [],
      selectedPeca: { id: null },
      selectedCategoria: { id: null },
      currentPage: 1,
      criatividade: "",
      inovacao: "",
      pertinencia: "",
      categoriaType: "", // PUBLICITARIO | FORNECEDOR | ESTUDANTE | PROFISSIONAL_INDEPENDENTE
    };
  },
  methods: {
    handleChange() {
      this.criatividade = this.criatividade.replace(/,/g, ".");
      this.inovacao = this.inovacao.replace(/,/g, ".");
      this.pertinencia = this.pertinencia.replace(/,/g, ".");
    },
    resetVoteModal() {
      this.selectedPeca = { id: null };
      this.criatividade = "";
      this.inovacao = "";
      this.pertinencia = "";
    },
    openVoteModal(peca) {
      this.selectedPeca = peca;
      this.showModal = true;
    },
    async saveVote() {
      const strUser = localStorage.getItem("user@mf");
      if (strUser) {
        const user = JSON.parse(strUser);
        let idPecaPublicitaria = null;
        let idPecaFornecedor = null;
        let idPecaEstudante = null;
        let idPecaProfissionalIndependente = null;

        switch (this.categoriaType) {
          case "PUBLICITARIO":
            idPecaPublicitaria = this.selectedPeca.id;
            break;
          case "FORNECEDOR":
            idPecaFornecedor = this.selectedPeca.id;
            break;
          case "PROFISSIONAL_INDEPENDENTE":
            idPecaProfissionalIndependente = this.selectedPeca.id;
            break;
          case "ESTUDANTE":
            idPecaEstudante = this.selectedPeca.id;
            break;
        }
        const resposta = {
          id: "",
          idJurado: user.details.id,
          idPecaPublicitaria: idPecaPublicitaria || null,
          idPecaFornecedor: idPecaFornecedor || null,
          idPecaEstudante: idPecaEstudante || null,
          idPecaProfissionalIndependente:
            idPecaProfissionalIndependente || null,
          criatividade: Number(this.criatividade),
          inovacao: Number(this.inovacao),
          pertinencia: Number(this.pertinencia),
        };

        try {
          await api.post("/jurado-resposta", resposta);
          switch (this.categoriaType) {
            case "PUBLICITARIO":
              this.loadPecaPublicitaria(this.selectedCategoria.id);
              break;
            case "FORNECEDOR":
              this.loadPecaFornecedor(this.selectedCategoria.id);
              break;
            case "PROFISSIONAL_INDEPENDENTE":
              this.loadPecaProfissionalIndependente(this.selectedCategoria.id);
              break;
            case "ESTUDANTE":
              this.loadPecaEstudante(this.selectedCategoria.id);
              break;
          }
        } catch (err) {
          if (err.response.status == 403) {
            this.$swal("Oops!", "Essa peça já foi votada!");
          } else {
            this.$swal(
              "Oops!",
              "Ocorreu um problema ao votar nessa peça. Por favor, tente novamente mais tarde."
            );
          }
        }
      }
    },
    async loadPecaPublicitaria(idCategoriaPecaPublicitaria) {
      try {
        this.loadingListagem = true;
        const strUser = localStorage.getItem("user@mf");
        if (idCategoriaPecaPublicitaria && strUser) {
          const user = JSON.parse(strUser);
          const response = await api.get(
            `/peca-publicitaria/categoria-peca-publicitaria/${idCategoriaPecaPublicitaria}?size=10000`
          );
          this.categoriaType = "PUBLICITARIO";
          let pecas = response.data.data;

          const responseResp = await api.get("/jurado-resposta?size=15000");
          const respostas = responseResp.data.data;
          pecas = pecas.map((p) => {
            if (
              respostas.some(
                (r) =>
                  r.idPecaPublicitaria == p.id && r.idJurado == user.details.id
              )
            ) {
              p.votado = true;
            }
            return p;
          });

          this.pecas = pecas;
        }
      } catch (err) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao listar peças publicitárias. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loadingListagem = false;
      }
    },
    async loadPecaProfissionalIndependente(
      idCategoriaPecaProfissionalIndependente
    ) {
      try {
        this.loadingListagem = true;
        const strUser = localStorage.getItem("user@mf");
        if (idCategoriaPecaProfissionalIndependente && strUser) {
          const user = JSON.parse(strUser);
          const response = await api.get(
            `/peca-profissional-independente/categoria-peca-profissional-independente/${idCategoriaPecaProfissionalIndependente}?size=10000`
          );
          this.categoriaType = "PROFISSIONAL_INDEPENDENTE";
          let pecas = response.data.data;

          const responseResp = await api.get("/jurado-resposta?size=15000");
          const respostas = responseResp.data.data;
          pecas = pecas.map((p) => {
            if (
              respostas.some(
                (r) =>
                  r.idPecaProfissionalIndependente == p.id &&
                  r.idJurado == user.details.id
              )
            ) {
              p.votado = true;
            }
            return p;
          });

          this.pecas = pecas;
        }
      } catch (err) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao listar peças de profissionais independente. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loadingListagem = false;
      }
    },
    async loadPecaFornecedor(idCategoriaPecaFornecedor) {
      try {
        this.loadingListagem = true;
        const strUser = localStorage.getItem("user@mf");
        if (idCategoriaPecaFornecedor && strUser) {
          const user = JSON.parse(strUser);
          const response = await api.get(
            `/peca-fornecedor/categoria-peca-fornecedor/${idCategoriaPecaFornecedor}?size=10000`
          );
          this.categoriaType = "FORNECEDOR";
          let pecas = response.data.data;

          const responseResp = await api.get("/jurado-resposta?size=15000");
          const respostas = responseResp.data.data;
          pecas = pecas.map((p) => {
            if (
              respostas.some(
                (r) =>
                  r.idPecaFornecedor == p.id && r.idJurado == user.details.id
              )
            ) {
              p.votado = true;
            }
            return p;
          });

          this.pecas = pecas;
        }
      } catch (err) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao listar peças de fornecedores. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loadingListagem = false;
      }
    },
    async loadPecaEstudante(idCategoriaEstudante) {
      try {
        this.loadingListagem = true;
        const strUser = localStorage.getItem("user@mf");
        if (idCategoriaEstudante && strUser) {
          const user = JSON.parse(strUser);
          const response = await api.get(
            `/peca-estudante/categoria-peca-estudante/${idCategoriaEstudante}?size=10000`
          );

          this.categoriaType = "ESTUDANTE";
          let pecas = response.data.data;

          const responseResp = await api.get("/jurado-resposta?size=15000");
          const respostas = responseResp.data.data;
          pecas = pecas.map((p) => {
            if (
              respostas.some(
                (r) =>
                  r.idPecaEstudante == p.id && r.idJurado == user.details.id
              )
            ) {
              p.votado = true;
            }
            return p;
          });

          this.pecas = pecas;
        }
      } catch (err) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao listar peças de estudantes. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loadingListagem = false;
      }
    },
    async findCategoria() {
      this.loadingCategoria = true;
      try {
        api
          .get(`/categoria-peca-publicitaria/senha/${this.senhaCategoria}`)
          .then((respCategoriaPub) => {
            // categoria publicitaria
            this.selectedCategoria = respCategoriaPub.data;
            this.loadPecaPublicitaria(this.selectedCategoria.id);
          })
          .catch(async (error) => {
            if (error.response) {
              api
                .get(`/categoria-peca-estudante/senha/${this.senhaCategoria}`)
                .then((respCategoriaPub) => {
                  // categoria publicitaria
                  this.selectedCategoria = respCategoriaPub.data;
                  this.loadPecaEstudante(this.selectedCategoria.id);
                })
                .catch(async (error) => {
                  if (error.response) {
                    api
                      .get(
                        `/categoria-peca-profissional-independente/senha/${this.senhaCategoria}`
                      )
                      .then((respCategoriaProInd) => {
                        // categoria fornecedor
                        this.selectedCategoria = respCategoriaProInd.data;
                        this.loadPecaProfissionalIndependente(
                          this.selectedCategoria.id
                        );
                      })
                      .catch(async (error) => {
                        if (error.response) {
                          api
                            .get(
                              `/categoria-peca-fornecedor/senha/${this.senhaCategoria}`
                            )
                            .then((respCategoriaForn) => {
                              // categoria fornecedor
                              this.selectedCategoria = respCategoriaForn.data;
                              this.loadPecaFornecedor(
                                this.selectedCategoria.id
                              );
                            })
                            .catch((error) => {
                              if (error.response) {
                                // senha incorreta
                                this.pecas = [];
                                this.$swal(
                                  "Oops!",
                                  "Verifique a senha da categoria e tente novamente."
                                );
                              }
                            });
                        }
                      });
                  }
                });
            }
          });
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingCategoria = false;
      }
    },
  },
};
</script>
<style></style>
